import * as requestFromServer from './popupAddReceiptCrud';
import moment from 'moment';
import {popupAddReceiptSlice, callTypes} from './popupAddReceiptSlice';
import {messages as M} from '../../../../../../_metronic/i18n/messages';
import {showGlobalMessage} from '../../../../_common/actions/globalMessage/showGlobalMessage';
import {logUserAction} from '../../../../../../utils';
import {pages as P} from '../../../../_common/constants/pages';
import {subjects as S} from '../../../../_common/constants/subjects';
import {actionTypes as T} from '../../../../_common/constants/actionTypes';
import {logMessages as L} from '../../../../_common/constants/logMessages';
import {checkArrayGetSum} from '../../../../InvoiceOrders/utils/checkArrayGetSum';

const {actions} = popupAddReceiptSlice;

export const findCustomerAgent = (customerID, isAgent) => (dispatch) => {
  dispatch(actions.startCall({callType: callTypes.data}));

  return requestFromServer
    .findCustomerAgent(customerID, isAgent)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(actions.popupAddReceiptFetched({
        entities: data
      }));

      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};

export const createInvoiceReceiptNewAgent = data => dispatch => {

  return requestFromServer
    .createInvoiceReceiptNewAgent(data)
    .then(response => {
      const {errorCode, data: responseData} = response.data;
      logUserAction(
        P.RECEIPTS,
        S.RECEIPT,
        T.CREATE,
        L.RECEIPTS_CREATE_FOR_NEW_AGENT(
          data?.agentID,
          data?.dueDate ? moment(data.dueDate).format('DD-MM-YYYY') : '',
          checkArrayGetSum(data?.lines)
        ),
       errorCode
      );

      const {client_message} = responseData;
      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(showGlobalMessage(client_message || M[errorCode]));
      }

      return errorCode
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};

export const createInvoiceReceiptExistingAgent = data => dispatch => {
  const dueDates = data?.lines && Array.isArray(data?.lines)
    ? data?.lines.map(item => item?.dueDate ? moment(item?.dueDate).format('DD-MM-YYYY') : '').filter(Boolean).join(', ')
    : '';

  return requestFromServer
    .createInvoiceReceiptExistingAgent(data)
    .then(response => {
      const {errorCode, data: responseData} = response.data;
      logUserAction(
        P.RECEIPTS,
        S.RECEIPT,
        T.CREATE,
        L.RECEIPTS_CREATE_FOR_EXISTING_AGENT(
          data?.agentID,
          dueDates,
          checkArrayGetSum(data?.lines)
        ),
        errorCode
      );
      const {client_message} = responseData;
      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(showGlobalMessage(client_message || M[errorCode]));
      }

      return errorCode
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    });
};

export const saveDisabledFields = disabledFields => dispatch => {
  dispatch(actions.saveDisabledFields({disabledFields}));
}

export const resetDisabledFields = () => dispatch => {
  dispatch(actions.saveDisabledFields({disabledFields: []}));
}

export const uploadMultiAgentsFile = file => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  const formData = new FormData();
  formData.set('content', file);

  return requestFromServer
    .uploadMultiAgentsFile({formData})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();
      const {parsed, failed} = data;

      dispatch(actions.uploadedAgentsFetched({
        parsedUploadedAgents: parsed,
        failedUploadedAgents: failed,
      }));

      return data
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "can't upload file!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};
